import { render, staticRenderFns } from "./ParamsList.vue?vue&type=template&id=08d3dc92"
import script from "./ParamsList.vue?vue&type=script&lang=js"
export * from "./ParamsList.vue?vue&type=script&lang=js"
import style0 from "./ParamsList.vue?vue&type=style&index=0&id=08d3dc92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports